/**
 * Ajax Pagination
 */
const pagination = {

	// Variables
	show: 9,
	total: 1,
	page: 1,
	numPages: 1,
	$parent: $('.pagination.ajax'),
	$posts: $('.block.tips.show-all .items, .block.contractors .items, .block.rebates .content .items'),
	classes: {
		buttons: '.pagination-buttons',
		next: '.page-button.next',
		prev: '.page-button.previous',
		page: '.page-button.page',
		post: '.item',
	},
	templates: {
		next: $('.pagination.ajax .pagination-templates > .next a'),
		prev: $('.pagination.ajax .pagination-templates > .prev a'),
		page: $('.pagination.ajax .pagination-templates > .page a'),
	},

	// Initialize
	init: function() {
		// Check to make sure we have all the needed divs
		var errors = false

		if (!this.$parent.length) { 
			errors = true 
			// console.log('Failed to find parent container.') 
		}

		if (!this.$posts.length) { 
			errors = true 
			// console.log('Failed to find the posts container.') 
		}
        
		if (errors) { return false }

		// Bind event listeners
		this.$parent.on('click', this.classes.page, this.onClickPage.bind(this))
		this.$parent.on('click', this.classes.next, this.onClickNextPrev.bind(this))
		this.$parent.on('click', this.classes.prev, this.onClickNextPrev.bind(this))
	},

	// Set how many items to show per page
	setPerPage: function(value) {
		this.show = value
		this.updateNumPages()
	},

	// Set the total number of items
	setTotal: function(value) {
		this.total = value
		this.updateNumPages()
	},

	// Update the number of pages based on other data
	updateNumPages: function() {
		this.numPages = Math.ceil(this.total / this.show)

		// Show pagination only if we have more than 1 page
		if (this.numPages == 1) this.$parent.hide()
		else this.$parent.show()
	},

	// Go to the specified page
	gotoPage: function(value) {
		if (value < 1) value = 1
		if (value > this.numPages) value = this.numPages
		this.page = parseInt(value)
		this.updateClasses()
		this.updatePosts(true)
	},

	// Update classes based on current page
	updateClasses: function() {
		$(this.classes.page, this.$parent).removeClass('active')
		$(this.classes.page+'[data-page="'+this.page+'"]').addClass('active')
		$(this.classes.next, this.$parent).removeClass('disabled')
		$(this.classes.prev, this.$parent).removeClass('disabled')
		if (this.page == 1) $(this.classes.prev, this.$parent).addClass('disabled')
		else if (this.page == this.numPages) $(this.classes.next, this.$parent).addClass('disabled')
	},

	// Update the posts view
	updatePosts: function(scrollToContent = false) {
		// If we only have 1 page of items, exit early
		if (this.numPages == 1) return false

		// Figure out which slice of items to show
		var start = (this.page - 1) * this.show
		var end = start + this.show

		// Show slice of posts
		$(this.classes.post, this.$posts).hide().slice(start, end).show()

		// Scroll to content
		if (scrollToContent) {
			var height = this.$posts.offset().top - 380
			$('html, body').animate({scrollTop: height}, 100)
		}
	},

	// If clicked on a page number
	onClickPage: function(e) {
		var div = e.currentTarget

		// Do nothing if we are already on the page
		if ($(div).hasClass('active')) { return false }

		// Go to the page
		var page = $(div).attr('data-page')
		this.gotoPage(page)
	},

	// If clicked on next
	onClickNextPrev: function(e) {
		var div = e.currentTarget

		// Do nothing if it's disabled
		if ($(div).hasClass('disabled')) { return false }

		// Go next
		if ($(div).hasClass('next')) {
			this.gotoPage(this.page + 1)
		}

		// Go previous
		if ($(div).hasClass('previous')) {
			this.gotoPage(this.page - 1)
		}
	},

	// Update the pagination snippet
	update: function() {
		var buttonsContainer = $(this.classes.buttons, this.$parent)
		var buttonPage = $(this.templates.page, this.$parent)
		var buttonPrev = $(this.templates.prev, this.$parent)
		var buttonNext = $(this.templates.next, this.$parent)

		// Reset
		buttonsContainer.empty()
		this.page = 1

		// Find out how many pages we need
		var numPages = Math.ceil(this.total / this.show)

		// If we have zero pages, quit early
		if (!numPages) return false

		// Make a prev button
		buttonPrev.clone().appendTo(buttonsContainer)

		// Make a button for each page
		for (var i = 1; i <= numPages; i++) {
			var clone = buttonPage.clone()
			clone.find('.page-button').attr('data-page', i).find('span').html(i)
			if (i == 1) clone.find('.page-button').addClass('active')
			clone.appendTo(buttonsContainer)
		}

		// Make a next button
		buttonNext.clone().appendTo(buttonsContainer)

		// Update posts view
		this.updatePosts()
	},
}

$(() => {
    window.pagination = pagination
    window.pagination.init()
})